import styled from 'styled-components'

export const StyledStrokes = styled.div`
    margin-top: 20px;
`